/**
 * The command palette's page catalog, gated for the current user and org — the
 * single "navigable pages" source shared by the palette and the tab strips'
 * "+" new-tab picker. See lib/navigablePages.
 */
import { useMemo } from 'react';
import { useCapability } from '@/hooks/useCapabilities';
import { filterNavigablePages, type NavigablePage } from '@/lib/navigablePages';
import { config } from '@/src/config';

export function useNavigablePages(organizationId: number | null, userRole?: string | null): NavigablePage[] {
  // Social Needs Screener is gated per org via the feature-capability registry.
  const { enabled: screenerCapEnabled } = useCapability(organizationId, 'social_needs_screening');
  // FFS transition cohort (TRUS-739): sensitive, off unless the org turned it on.
  const { enabled: ffsTransitionCapEnabled } = useCapability(organizationId, 'ffs_transition');
  return useMemo(
    () =>
      filterNavigablePages({
        isTriveny: config.isTriveny,
        userRole,
        activeOrgId: organizationId,
        screenerCapEnabled,
        ffsTransitionCapEnabled,
      }),
    [organizationId, userRole, screenerCapEnabled, ffsTransitionCapEnabled],
  );
}

export default useNavigablePages;
